import React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import FieldsForm from "./FieldsForm";
import ShareForm from "./ShareForm";
import NotificationsForm from "./NotificationsForm";
import EventDefinitionSummary from "./EventDefinitionSummary";
const COMMON_STEP_KEYS = {
  ADDITIONAL_DETAILS: "additional-details",
  NOTIFICATIONS: "notifications",
  SHARE: "Share",
  SUMMARY: "summary"
};
export const COMMON_STEP_TELEMETRY_KEYS = [
  TELEMETRY_EVENT_TYPE.EVENTDEFINITION_FIELDS.STEP_CLICKED,
  TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.STEP_CLICKED,
  TELEMETRY_EVENT_TYPE.EVENTDEFINITION_SUMMARY.STEP_CLICKED
];
export const INITIAL_EVENT_DEFINITION = {
  _scope: "DEFAULT",
  title: "",
  description: "",
  priority: EventDefinitionPriorityEnum.MEDIUM,
  // @ts-ignore
  config: {},
  field_spec: {},
  key_spec: [],
  notification_settings: {
    grace_period_ms: 3e5,
    // Defaults to system setting for notification backlog size
    backlog_size: null
  },
  notifications: [],
  tags: [],
  alert: false,
  tactics_techniques: []
};
const getConditionPlugin = (edType) => {
  if (edType === void 0) return {};
  return PluginStore.exports("eventDefinitionTypes").find((eventDefinitionType) => eventDefinitionType.type === edType) || {};
};
const defaultCommonStepProps = {
  key: "",
  action: "create",
  eventDefinition: INITIAL_EVENT_DEFINITION,
  onChange: void 0,
  validation: {
    errors: {}
  },
  currentUser: void 0
};
function useEventDefinitionSteps({
  viewSteps,
  commonStepProps = defaultCommonStepProps,
  notifications = [],
  notificationDefaults = { default_backlog_size: 0 },
  hideFieldsStep = false,
  canEdit = false,
  summaryComponent = void 0
}) {
  var _a, _b, _c, _d;
  const isNew = commonStepProps.action === "create";
  const conditionPlugin = getConditionPlugin((_b = (_a = commonStepProps == null ? void 0 : commonStepProps.eventDefinition) == null ? void 0 : _a.config) == null ? void 0 : _b.type);
  const shouldHideFieldsStep = hideFieldsStep || ((_c = conditionPlugin == null ? void 0 : conditionPlugin.hideFieldsStep) != null ? _c : false);
  const resolvedCommonStepProps = {
    ...commonStepProps,
    validation: (_d = commonStepProps.validation) != null ? _d : { errors: {} }
  };
  return [
    ...viewSteps,
    {
      key: COMMON_STEP_KEYS.ADDITIONAL_DETAILS,
      title: "Additional Details",
      component: /* @__PURE__ */ React.createElement(FieldsForm, { ...resolvedCommonStepProps, canEdit }),
      hidden: shouldHideFieldsStep
    },
    {
      key: COMMON_STEP_KEYS.NOTIFICATIONS,
      title: "Notifications",
      component: /* @__PURE__ */ React.createElement(NotificationsForm, { ...resolvedCommonStepProps, notifications, defaults: notificationDefaults })
    },
    {
      key: COMMON_STEP_KEYS.SHARE,
      title: "Share",
      component: /* @__PURE__ */ React.createElement(ShareForm, { ...resolvedCommonStepProps }),
      hidden: !isNew
    },
    {
      key: COMMON_STEP_KEYS.SUMMARY,
      title: "Summary",
      component: summaryComponent ? summaryComponent : /* @__PURE__ */ React.createElement(
        EventDefinitionSummary,
        {
          eventDefinition: commonStepProps.eventDefinition,
          currentUser: commonStepProps.currentUser,
          notifications,
          validation: commonStepProps.validation
        }
      )
    }
  ].filter((step) => !step.hidden);
}
export default useEventDefinitionSteps;
